import { PrefetchLink } from "@/components/routing/PrefetchLink";
import { Box, Text } from "@mantine/core";
import styles from "../category/styles/CategoryTile.module.css";
import curated from "../curated/styles/Curated.module.css";
import {
    CoverCredit,
    CoverOverlay,
    CoverPicture,
    GradientCover,
    useCreditRoom,
} from "@/components/curated/CuratedCover";
import { coverOf } from "@/core/cover";
import { filterText, truncate } from "@/core/helpers";
import { Urls } from "@/core/urls";

const TILE_SIZES = "(width <= 48em) 100vw, 360px";

export const SubjectTile = ({ subject }: { subject: Subject }) => {
    const cover = coverOf(subject);
    const [creditRoom, creditRef] = useCreditRoom();
    const tile = (
        <PrefetchLink className={styles.tile} to={Urls.focusArea(subject.slug)}>
            <Box pos="relative">
                {cover ? (
                    <CoverPicture className={curated.tileImage} cover={cover} sizes={TILE_SIZES} widths={[360, 720]} />
                ) : (
                    <GradientCover className={curated.tileGradient} seed={subject.slug} />
                )}
                <CoverOverlay
                    creditRoom={cover ? creditRoom : undefined}
                    scrim={cover ? "photo" : "light"}
                    count={
                        subject.episodes_count ? (
                            <Text c="gray.3" size="sm">
                                {subject.episodes_count} avsnitt
                            </Text>
                        ) : null
                    }
                    title={
                        <Text c="white" fw={700} lh={1.25} lineClamp={2} size="lg">
                            {subject.name}
                        </Text>
                    }
                />
            </Box>
            <div className={styles.body}>
                {subject.content && (
                    <Text c="dimmed" className={curated.excerpt} lineClamp={4} size="sm">
                        {truncate(filterText(subject.content), 220)}
                    </Text>
                )}
                <span className={styles.cta}>Börja lyssna →</span>
            </div>
        </PrefetchLink>
    );

    if (!cover) return tile;
    return (
        <div className={curated.tileWrap}>
            {tile}
            <CoverCredit className={curated.tileCredit} cover={cover} ref={creditRef} />
        </div>
    );
};
